import { render, staticRenderFns } from "./invoice_add.vue?vue&type=template&id=5b8642fb&"
import script from "./invoice_add.vue?vue&type=script&lang=js&"
export * from "./invoice_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports